var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showChosen)?_c('div',[(_vm.chosenFiles.length > 0)?_c('files',{attrs:{"existing-files":_vm.chosenFiles,"download-url-factory":_vm.getDownloadUrl}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }